<template>
    <div class="container-collapse">
        <div class="collapse-header">
            <div class="step-label">
                <div class="step-icon">
                    <slot name="step-number"></slot>
                </div>
                <div class="step-content">
                    <slot name="title"></slot>
                </div>
            </div>
            <div :id="collapseId" v-b-toggle="collapseId" class="dropdown" :class="{ 'rotate': isOpen }">
                <img class="dropdown-icon" src="@/assets/images/dropdown.svg" alt="arrow">
            </div>
            <div v-if="dropdown" class="collapse-overlay"></div>
        </div>

        <b-collapse :id="collapseId" class="mt-2" :visible="isOpen">
            <div class="inner-collapse">
                <slot name="collapse-content"></slot>
            </div>
        </b-collapse>
    </div>
</template>

<script>
export default {
    name: "OnboardingCollapseSteps",
    props: {
        collapseId: {
            type: String,
            required: true
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        dropdown: {
            type: Boolean,
            default: false
        }

    }
};
</script>
<style lang="scss" scoped>
.dropdown-container {
    position: relative;
}

.collapse-overlay {
    position: absolute;
    right: 20px;
    top: 30px;
    width: 30px;
    height: 40px;
    opacity: 0.2;
    z-index: 999;
    padding: 0px;
    cursor: not-allowed;
}

.container-collapse {
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #e9ebed;
    background: #fff;
    box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);
    overflow: hidden;
    width: 100%;
    height: 100%;

    .collapse-header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e9ebed;
        padding: 32px 25px 32px 27px;
        margin-left: -10px;
        margin-right: -10px;
        margin-bottom: -11px;
        height: 100%;

        .step-label {
            display: flex;
            align-items: center;
            color: var(--6-neutrals-grey-800, #2f3941);
            font-family: MainFontRegular, sans-serif;
            font-size: 16px;
            font-style: normal;
            line-height: normal;

            .step-icon {
                margin-bottom: 30px;

            }

            .step-content {
                margin-left: 15px;
            }

            .sub-title {
                color: var(--6-neutrals-grey-600, #68737d);
                font-size: 14px;
                line-height: 20px;
            }
        }

        .dropdown-icon {
            margin-top: -20px;
            height: 24px;
            width: 24px;
            transform: rotate(180deg);
        }

        .collapsed {
            margin-top: -40px;
            transform: rotate(180deg);
        }
    }
}
</style>
